import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const clearEntries: YJSChangeHandler<DatabaseChangeType.CLEAR_ENTRIES> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    for (const entryId of change.entryIds || db.entries) {
      for (const fieldId of change.fieldIds || db.fields) {
        const existingFieldType = db.fieldsById[fieldId].type;
        const entry = db.entriesById[entryId];

        entry.removeValue(fieldId);

        // set an empty value for the field
        entry.setValue(fieldId, existingFieldType);
      }
    }
  });
};
